import { render, staticRenderFns } from "./DatatableComponent.vue?vue&type=template&id=592d0ff4&scoped=true"
import script from "./DatatableComponent.vue?vue&type=script&lang=js"
export * from "./DatatableComponent.vue?vue&type=script&lang=js"
import style0 from "./DatatableComponent.vue?vue&type=style&index=0&id=592d0ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d0ff4",
  null
  
)

export default component.exports